import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';


@Component({
  selector: 'btn-delete-cell-renderer',
  template:`
    <button type="button" data-cy="delete" class="delete-button" (click)="btnClickedHandler($event)"><img src="../assets/images/delete-button.svg" width="18" height="18"/></button>
  `,
})

export class BtnDeleteCellRenderer implements ICellRendererAngularComp, OnDestroy {
  private params: any;

  agInit(params: any): void {
    this.params = params;
  }

  btnClickedHandler(event) {
    this.params.clicked(this);
  }

  refresh(): boolean {
    return false;
  }

  ngOnDestroy() {
    // no need to remove the button click handler 
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
